export default __webpack_public_path__ + "static/media/sar.75b67625.png";